export const formatFileSize = (bytes) => {
  if (!bytes) {
    return "0 B";
  }
  const units = ["B", "KB", "MB", "GB", "TB"];
  const unitIndex = Math.min(
    Math.floor(Math.log(bytes) / Math.log(1024)),
    units.length - 1,
  );
  const value = bytes / 1024 ** unitIndex;
  return `${value.toFixed(value >= 10 || unitIndex === 0 ? 0 : 1)} ${
    units[unitIndex]
  }`;
};

export const formatModifiedAt = (value) => {
  if (!value) {
    return "—";
  }
  return new Intl.DateTimeFormat("it-IT", {
    dateStyle: "short",
    timeStyle: "short",
  }).format(new Date(value));
};

export const getItemNameFromPath = (path) =>
  (path || "").replace(/\/$/, "").split("/").pop() || "";

export const buildDestinationKey = ({ currentPath = "", name, type }) =>
  `${currentPath}${name}${type === "folder" ? "/" : ""}`;

export const buildMissionControlLink = ({
  key,
  mode = "view",
  environment,
  origin = window.location.origin,
}) => {
  const url = new URL("/internal-drive", origin);
  url.searchParams.set("open", key);
  if (environment) {
    url.searchParams.set("env", environment);
  }
  if (mode !== "view") {
    url.searchParams.set("mode", mode);
  }
  return url.toString();
};
